import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Button,
  UserIconWhite,
  UserIconThinWhite,
  DropdownButtonLink,
  Paragraph,
} from "@sentara-health/optimahealth_web";

import { toPascalCase } from "../../utils/helpers/TextFormaters";
import { Brands, useAuth, useBranding } from "../../providers";

const getUserIcon = (brand: Brands): JSX.Element => {
  switch (brand) {
    case Brands.AVMED:
      return <UserIconThinWhite />;
    case Brands.SENTARA_HEALTH_PLANS:
      return <UserIconWhite />;
  }
};

// Define the Logout component
export const ProfileMenu = () => {
  // Initialize translation function
  const { t } = useTranslation();
  const { brandConfig, brand } = useBranding();
  const navigate = useNavigate();

  const { user } = useAuth();
  // Convert the user's name to PascalCase
  const capitalizedText = toPascalCase(user?.person?.firstName ?? "");

  return (
    <div className="d-xl-block d-lg-block d-md-block pos-rel">
      <div className="d-flex align-items-center">
        <DropdownButtonLink
          buttonlabel={capitalizedText}
          buttonLabelLevel={3}
          buttonLabelVariant={brandConfig.brandName === Brands.AVMED ? "semiBold" : "bold"}
          dataTestId="profile-dropdown-button"
          dropdownlistitems={[]}
          icon={getUserIcon(brand)}
        >
          <>
            {Object.keys(brandConfig.profileMenuLinks).map((key: string) => {
              const item = brandConfig.profileMenuLinks[key];
              return (
                <li key={key}>
                  <NavLink
                    key={key}
                    to={item.to}
                    className="dropdown-item text-decoration-none"
                    data-testid={item.id}
                  >
                    <Paragraph
                      className="mb-1 py-1"
                      text={t(item.title)}
                      level={3}
                      variant={brandConfig.brandName === Brands.AVMED ? "semiBold" : "bold"}
                      data-testid={`dropDownItem-${key}`}
                    />
                  </NavLink>
                </li>
              );
            })}
            <li>
              {/* Button to trigger the signOutHandler function */}
              <Button
                data-testid={"btnSignOut"}
                className={"primary-color dropdown-item"}
                onClick={() => {
                  navigate("/logout");
                }}
              >
                {t("logout")}
              </Button>
            </li>
          </>
        </DropdownButtonLink>
      </div>
    </div>
  );
};
